let apiKey = 'ca710c5c7e60143c48dc86aa6efca6ff'; //m
// let apiKey = 'ca544697c48cca918d7f2cc001774bb3;'; //p
//let apiKey = 'f1550428ae52421640c3504279566d89'; //mk
let apiEndpoint = 'https://api.openweathermap.org/data/2.5/';

export { apiEndpoint, apiKey };
